import { useEffect, Suspense, lazy } from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Contact from "./components/Contact";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Aos from "aos";
import "aos/dist/aos.css";
import ScrollToTopButton from "./components/ScrollToTopButton";
import { motion } from "framer-motion";

const About = lazy(() => import("./components/About"));
const Projects = lazy(() => import("./components/Projects"));
const Experience = lazy(() => import("./components/Experience"));
const Skills = lazy(() => import("./components/Skills"));

function App() {
  useEffect(() => {
    // Defer AOS initialization to prevent forced reflow on initial mount
    setTimeout(() => {
      Aos.init({
        duration: 800,
        once: true,
      });
    }, 150);


    // Initial scroll and popstate handler for clean URLs
    const handleNavigation = () => {
      const path = window.location.pathname;
      if (path !== "/") {
        // Convert /about to #about
        const id = path.replace("/", "#");
        // Try to find the element
        const element = document.querySelector(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        } else {
          // Retry for lazy loaded components
          setTimeout(() => {
            const el = document.querySelector(id);
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }, 300);
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    window.addEventListener("popstate", handleNavigation);

    // Check initial load
    setTimeout(handleNavigation, 100);

    return () => {

      window.removeEventListener("popstate", handleNavigation);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-950 text-white font-sans relative overflow-x-hidden w-full max-w-full">
      {/* 3D Background Scene */}
      <div className="relative z-10">
        <Navbar />

        <main>
          <Hero />

          <Suspense
            fallback={
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="flex items-center justify-center py-20"
              >
                <div className="relative">
                  <motion.div
                    className="w-16 h-16 border-4 border-cyan-500/30 border-t-cyan-500 rounded-full"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                  />
                  <motion.div
                    className="absolute inset-0 w-16 h-16 border-4 border-cyan-500/30 border-t-cyan-500 rounded-full"
                    animate={{ rotate: -360 }}
                    transition={{
                      duration: 1.5,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                  />
                </div>
              </motion.div>
            }
          >
            <About />
            <Skills />
            <Projects />
            <Experience />
          </Suspense>

          <Contact />
        </main>
        <ScrollToTopButton />
        <Analytics />
        <SpeedInsights />
      </div>
    </div>
  );
}

export default App;
